module.exports = __webpack_public_path__ + "static/media/popcorn.0321357b.svg";